import { render } from "./RelatedArticles.vue?vue&type=template&id=9d65de2e"
import script from "./RelatedArticles.vue?vue&type=script&lang=js"
export * from "./RelatedArticles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__